import axios from "axios";

var counter = 0;
const win: any = window;
var apigeeReGenerateTokenUrl: any = win["regenerate_apigee_url"];
var serverURL: any = win["base_portal_url"];
var errorPage: any = win["errorPageURL"];

const url = new URL(window.location.href);
const xId = url.searchParams.get("xCoId") ?? "";
const pId = url.searchParams.get("pId");
const isLocalhost = window.location.hostname.includes("localhost");

const cem_key = isLocalhost ? import.meta.env.VITE_APP_CMK : win["CEM_KEY"];
let apigeeclientToken = isLocalhost ? import.meta.env.VITE_APP_ACT : win['apigeeclientToken'];
const token = isLocalhost ? import.meta.env.VITE_APP_ACT : win['apigeeclientToken'];

const apigeeBaseURL = isLocalhost ? "https://apisit.mobily.com.sa/api" : win["base_api_url"];
const apple_base_url = isLocalhost ? "https://apisit.mobily.com.sa/api" : win['base_api_url'];
const domain_url = isLocalhost ? "https://apisit.mobily.com.sa" : win['apigee_bm_base_url'];

const orderId = win['orderId'];

const apigeeConfig = {
    api: {
        baseURL: apigeeBaseURL,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "cem-key": cem_key,
            "X-Reference-Id": "SR_123hg87asfafF32"
        },
    },
}

export const apigeeSimpleApi = axios.create();
export const apigeeApi = axios.create({ ...apigeeConfig.api });

apigeeApi.defaults.validateStatus = function () {
    return true;
};

apigeeApi.interceptors.request.use(
    async (conf: any) => {
        conf.headers.Authorization = `Bearer ${apigeeclientToken}`;
        return conf;
    },
    (err) => {
        console.log("error in getting ", err);
    }
);

apigeeApi.interceptors.response.use(
    async (response) => {
        if (
            (response.data.code && response.data.code === "APIGEE-001") ||
            (response.data.code && response.data.code === "APIGEE-002")
        ) {
            counter++;
            apigeeclientToken = await reGenerateToken();
            const { config: oldRequest } = response;
            if (counter < 2) return apigeeApi.request({ ...oldRequest });
        }

        return response;
    },
    async (error) => {
        if (!!errorPage) {
            document.location.href = errorPage;
        }
        return error;
    }
);

function reGenerateToken() {
    console.log("apigeeReGenerateTokenUrl :: Enter");
    console.log("apigeeReGenerateTokenUrl => " + serverURL + "" + apigeeReGenerateTokenUrl);

    return new Promise((resolve, reject) => {
        fetch(serverURL + "" + apigeeReGenerateTokenUrl, {
            method: "GET",
            headers: {
                "Content-type": "text/html; charset=UTF-8",
            },
        })
            .then((res) => res.text())
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

// get method

const getValidateUrl = (referenceId: string, xCoId: string) => {
    const url = `${apigeeBaseURL}/url-generation/info/v1?referenceId=${referenceId}`;
    return apigeeApi.get(url, {
        headers: {
            "X-Correlation-Id": xCoId
        }
    });
}

function performValidation(validationURL: string) {
    let appDomain = window.location.hostname;

    return fetch(`${apple_base_url}/payment/v2/createApplePaySession`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "cem-key": cem_key,
            "Content-Type": "application/json; charset=utf-8",
            "X-Correlation-Id": xId,
        },
        body: JSON.stringify({
            applePayURL: validationURL,
            appDomain,
        }),
    });
}

function sendPaymentToken(applePayToken: any) {
    console.log("Payment Token Starts...");
    const returnUrl = window.localStorage.getItem("returnUrl");
    const userAgent = navigator.userAgent;
    const lang = "EN";

    const colorDepth = screen.colorDepth;
    const screenHeight = screen.height;
    const screenWidth = screen.width;
    const javaEnabled = navigator.javaEnabled();

    console.log("returnUrl", returnUrl);

    return fetch(`${apple_base_url}/payment/v2/createPayment`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "cem-key": cem_key,
            "Content-Type": "application/json; charset=utf-8",
            "X-Correlation-Id": xId,
        },
        body: JSON.stringify({
            paymentTransactionId: pId,
            paymentType: "ApplePay",
            paymentValue: JSON.stringify(applePayToken.paymentData),
            returnURL: returnUrl,
            tokenRequired: "No",
            browser: userAgent,
            language: lang,
            channel: "MAPP",
            javaEnabled: javaEnabled,
            screenHeight: screenHeight,
            screenWidth: screenWidth,
            colorDepth: colorDepth,
            timeZone: "-180",
            "3DSecureChallengeWindowSize": "FULL_SCREEN",
        }),
    });
}

function orderUpdateApi(res: any) {
    return fetch(`${domain_url}/api/OrderGenerator/updateOrderStatus/${orderId}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "cem-key": cem_key,
            "Content-Type": "application/json; charset=utf-8",
            "X-Correlation-Id": xId,
        },
        body: JSON.stringify({
            orderChangedBy: "Portal",
            orderStatus: "failed",
            orderStatusChangeReason: res.status.statusMessage,
            paymentStatus: "failed",
            processingDetails: [
                { key: "ErrorMessage", value: res.data.responseMessage },
                { key: "ErrorCode", value: res.status.statusCode },
                { key: "PaymentTransactionId", value: res.data.paymentTransactionId, },
            ],
        }),
    });
}

export { getValidateUrl, performValidation, sendPaymentToken, orderUpdateApi };